import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyService } from "../../services/company";
import { toast } from "react-hot-toast";

const PasswordDialog = ({ isOpen, onClose, initialData }) => {
  const [formData, setFormData] = useState({
    userId: 0,
    currentId: 0,
    address: "",
    notes: "",
    gender: 0,
    fullName: "",
    email: "",
    mobilePhones: "",
    status: true,
    password: "",
    birthDate: new Date().toISOString(),
    recordDate: new Date().toISOString(),
    updateContactDate: new Date().toISOString(),
  });

  const [password, setPassword] = useState("");
  const queryClient = useQueryClient();

  const generateRandomPassword = (length = 12) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    return Array.from({ length }, () =>
      characters.charAt(Math.floor(Math.random() * characters.length))
    ).join("");
  };

  const passwordMutation = useMutation({
    mutationFn: (newData) => companyService.updateUserPassword(newData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["Users"] });
      toast.success("Kullanıcı şifresi güncellendi");
    },
    onError: () => {
      toast.error("Bir hata oluştu");
    },
  });
 
  useEffect(() => {
    if (isOpen && initialData) { 
      setFormData(initialData);
      const newPassword = generateRandomPassword();
      setPassword(newPassword);

      const newData = { 
        userId: initialData.userId,
        password: newPassword,
      };
      passwordMutation.mutate(newData);
    } else if (!isOpen) {
      setPassword("");
    }// eslint-disable-next-line
  }, [isOpen, initialData]);
  const handlePrint = () => { 
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    const content = `
    <html>
      <head>
        <title>Yazdır</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 20px;
            padding: 0;
            box-sizing: border-box;
          }

          .print-container {
            width: 100%;
            max-width: 600px;
            margin: 0 auto;
          }

          .field-container {
            border: 1px solid #ddd;
            border-radius: 6px;
            padding: 10px 15px;
            margin-bottom: 15px;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          }

          .field-title {
            font-size: 14px;
            color: #555;
            margin-bottom: 8px;
            display: flex;
            align-items: center;
          }

          .field-title i {
            margin-right: 8px;
            color: #4CAF50;
          }

          .field-content {
            font-size: 16px;
            font-weight: bold;
            color: #222;
          }

          .field-content a {
            color: #007BFF;
            text-decoration: none;
          }

          .field-content a:hover {
            text-decoration: underline;
          }
        </style>
      </head>
      <body>
      <h1>BOYER TEKSTİL MÜŞTERİ PORTALI</h1>
      <h3>Kullanıcı Giriş Bilgileri</h3>
        <div class="print-container">
          <div class="field-container">
            <div class="field-title">
              <i class="pi pi-link"></i> Giriş URL
            </div>
            <div class="field-content">
              <a href="https://musteri.boyertekstil.com">https://musteri.boyertekstil.com</a>
            </div>
          </div>
          <div class="field-container">
            <div class="field-title">
              <i class="pi pi-user"></i> Firma
            </div>
            <div class="field-content">${formData?.current?.unvan.trim()}</div>
          </div>
          <div class="field-container">
            <div class="field-title">
              <i class="pi pi-envelope"></i> E-posta
            </div>
            <div class="field-content">${formData.email}</div>
          </div>
          <div class="field-container">
            <div class="field-title">
              <i class="pi pi-key"></i> Şifre
            </div>
            <div class="field-content">${password || "Henüz şifre oluşturulmadı"}</div>
          </div>
        </div>
      </body>
    </html>
  `;

    iframeDoc.open();
    iframeDoc.write(content);
    iframeDoc.close();

    // Yazdırma işlemi başlat
    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Yazdırma tamamlandıktan sonra iframe'i kaldır
    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  };

   
  
  const renderField = ({ icon, title, content, link }) => (
    <div className="col-12 p-card my-2 ">
      <div className="text-sm text-500 font-medium text-center p-2 
       	">
        <i className={`pi pi-${icon} mr-2`} />
        {title}
      </div>
      <div className="text-lg font-semibold text-900 text-center pt-2 border-top-1
     	border-400">
        {link ? (
          <a href={content} className="text-blue-500 hover:underline">
            {content}
          </a>
        ) : (
          content
        )}
      </div>
    </div>
  );

  const footer = (
    <div className="flex justify-content-between w-full">
      <Button
        label="Yazdır" text
        icon="pi pi-print"
        className="w-full"
        onClick={handlePrint}
        disabled={!password}
        style={{ marginRight: "10px" }}
      />
      <Button
        label="Kapat" text iconPos="right"
        icon="pi pi-times"
        onClick={onClose}
        className="p-button-danger w-full"
      />
    </div>
  );

  return (
    <Dialog
      header="Kullanıcı Bilgileri"
      visible={isOpen}
      onHide={onClose}
      footer={footer}
      style={{ width: "400px" }}
    >
      <div className="p-car2d m-0 p-3 mt-4">
      
        <div className="grid">
          {renderField({
            icon: "link",
            title: "Giriş URL",
            content: "https://musteri.boyertekstil.com",
            link: true,
          })}
          {renderField({
            icon: "user",
            title: "Firma",
            content: formData.current?.unvan?.trim(),
          })}
          {renderField({
            icon: "envelope",
            title: "E-posta",
            content: formData.email,
          })}
          {renderField({
            icon: "key",
            title: "Şifre",
            content: password || "Henüz şifre oluşturulmadı",
          })}
        </div>
      </div>
    </Dialog>
  );
};

export default PasswordDialog;
